import { Badge } from "@/components/ui/badge";
import { formatarNome } from "@/utils/formatarNome";
import { TooltipEasy } from "@/components/tooltipEasy";
import { Clock9, MapPin, User } from "lucide-react";
import obterBgBadge from "@/utils/obterBgBadge";
import calcularTempoRestante from "@/utils/calcularTempoRestante";
import { TempoRestante } from "./TempoRestante";
import moment from "moment";
import { PresetActions } from "./PresetActions";

function formatarNomeBadge(nome) {
  if (nome.length <= 25) {
    return nome;
  } else {
    return nome.slice(0, 22) + "...";
  }
}

export function ItemEquipe({ id, label, tempo_ate_agora = "", nome_aluno = "", servico = "", atendente, unidadeId, unidade, setorId, servicoId, prazo, createdAt, finalizado_data }) {

  const isConcluidos = label === "Concluídos"
  const bgBadge = isConcluidos ? obterBgBadge(0, createdAt) : obterBgBadge(prazo, createdAt)
  const prazoMinutos = calcularTempoRestante(prazo, createdAt)

  return (
    <div className="bg-white rounded-md p-2 relative">
      <div className="flex items-center justify-end gap-1 mb-[2px]">
        {!isConcluidos && <TempoRestante tempo={prazoMinutos} />}
        {isConcluidos ?
          (<TooltipEasy content="Data de encerramento"><Badge className={`${bgBadge} text-white`}><Clock9 />{moment(finalizado_data).format("DD/MM/YY HH:mm")}</Badge></TooltipEasy>) : (
            <TooltipEasy content={(<span>Horário de chegada<br />{moment(createdAt).format("DD/MM/YY HH:mm")}</span>)}><Badge className={`${bgBadge} text-white`}><Clock9 />{tempo_ate_agora}</Badge></TooltipEasy>)}
      </div >
      <div className="flex items-stretch gap-2">
        <div className="w-[4px] bg-[#b9b9b9] rounded-md flex-shrink-0" />
        <div className="grid grid-cols-1 px-2">
          <div className="px-2 py-1">
            <p className="text-sm/6 font-medium text-gray-900 w-full truncate">{formatarNome(nome_aluno)}</p>
            <p className="text-sm/6 text-gray-700 w-full truncate">{servico}</p>
            {atendente && <div className="mt-1 text-sm/6 text-gray-700"><Badge variant="secondary"><User />{formatarNomeBadge(formatarNome(atendente))}</Badge></div>}
            <div className="mt-1 text-sm/6 text-gray-700"><Badge variant="secondary"><MapPin />{unidade}</Badge></div>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1 absolute bottom-2 right-2">
        <PresetActions id={id} isConcluidos={isConcluidos} unidadeId={unidadeId} setorId={setorId} servicoId={servicoId} />
      </div>
    </div >
  )
}